import React, { useState } from 'react';
import { StickyBar } from '@ezetech/swag-space-x';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import Image from 'swag-client-common/components/ui/image';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import { LoadingOverlayType } from 'swag-client-common/components/ui/loading-overlay/loading-overlay';
import editIcon from 'assets/svg/edit-space.svg';
import deleteIcon from 'assets/svg/remove-space.svg';
import { ConfirmRemoveProductPopup } from './components/confirm-remove-product-popup';
import css from './added-cbs-products-widget.scss';
const tooltipClasses = {
  popper: css.popper
};
const Colors = props => {
  if (!props.variants.length) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.colorsWrapper
  }, "Colors:", ' ', /*#__PURE__*/React.createElement("div", {
    className: css.colors
  }, props.variants.map(({
    color,
    name
  }) => /*#__PURE__*/React.createElement(Tooltip, {
    title: name,
    key: color,
    placement: Placement.TOP,
    classes: tooltipClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: css.color,
    style: {
      backgroundColor: color
    }
  })))));
};
const Buttons = ({
  onEdit,
  onRemove
}) => /*#__PURE__*/React.createElement("div", {
  className: css.buttons
}, /*#__PURE__*/React.createElement(Image, {
  src: editIcon,
  alt: "editIcon",
  wrapperClassName: css.button,
  isUseLoader: false,
  onClick: onEdit
}), /*#__PURE__*/React.createElement(Image, {
  src: deleteIcon,
  alt: "deleteIcon",
  wrapperClassName: css.button,
  isUseLoader: false,
  onClick: onRemove
}));
const getVariantsBySelected = ({
  selectedVariants,
  prodVariants
}) => {
  const result = [];
  selectedVariants.forEach(selectedVariant => {
    const variant = prodVariants[selectedVariant.variantIndex];
    if (variant) {
      result.push(variant);
    }
  });
  return result;
};
const getLogoImage = ({
  customerMockups
}) => {
  const keys = Object.keys(customerMockups);
  if (!keys.length) {
    return '';
  }
  return customerMockups[keys[0]].fileName;
};
export const AddedCBSProductsWidget = ({
  shouldShowCBSProductsWidget,
  cbsProducts,
  isLoading,
  onEdit,
  onRemove
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => {
    //todo move to sticky widget component
    if (!isExpanded) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }
    setIsExpanded(!isExpanded);
  };
  const handleEditExpanded = product => {
    toggleExpand();
    onEdit(product);
  };
  if (!shouldShowCBSProductsWidget) {
    return null;
  }
  const count = cbsProducts.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StickyBar, {
    isExpanded: isExpanded,
    onExpandChange: toggleExpand,
    title: `Added products (${count})`,
    containerClassName: css.container,
    expandedContainerClassName: css.expandedContainer,
    expandedContainerBodyClassName: css.products,
    containerBodyClassName: css.products,
    iconWrapperClassName: css.iconWrapper,
    expandedBody: cbsProducts.map(product => /*#__PURE__*/React.createElement("div", {
      className: css.product,
      key: String(product._id),
      "data-product-id": String(product._id)
    }, /*#__PURE__*/React.createElement(Image, {
      wrapperClassName: css.image,
      src: getLogoImage(product),
      alt: "productImage"
    }), /*#__PURE__*/React.createElement("div", {
      className: css.productInfoWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: css.productInfo
    }, /*#__PURE__*/React.createElement("div", {
      className: css.name
    }, product.name), product.colored && /*#__PURE__*/React.createElement(Colors, {
      variants: getVariantsBySelected(product)
    })), /*#__PURE__*/React.createElement(Buttons, {
      onEdit: () => handleEditExpanded(product),
      onRemove: () => onRemove(String(product._id))
    })))),
    compressedBody: cbsProducts.map(product => /*#__PURE__*/React.createElement("div", {
      className: css.product,
      key: String(product._id),
      "data-product-id": String(product._id)
    }, /*#__PURE__*/React.createElement("div", {
      className: css.productInfoWrapper
    }, /*#__PURE__*/React.createElement(Image, {
      wrapperClassName: css.image,
      src: getLogoImage(product),
      alt: "productImage"
    }), /*#__PURE__*/React.createElement("div", {
      className: css.productInfo
    }, /*#__PURE__*/React.createElement("div", {
      className: css.name
    }, product.name), product.colored && /*#__PURE__*/React.createElement(Colors, {
      variants: getVariantsBySelected(product)
    }))), /*#__PURE__*/React.createElement(Buttons, {
      onEdit: () => onEdit(product),
      onRemove: () => onRemove(String(product._id))
    }))),
    commonContent: /*#__PURE__*/React.createElement(LoadingOverlay, {
      className: css.loader,
      isShown: isLoading,
      overlayingType: LoadingOverlayType.partial
    })
  }), /*#__PURE__*/React.createElement(ConfirmRemoveProductPopup, {
    text: "Are you sure you want to delete the product?"
  }));
};